import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=685c6983&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=685c6983&prod&lang=scss&scoped=true&"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=685c6983&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c6983",
  null
  
)

export default component.exports